<template>
  <div>
    <v-btn color="primary" text rounded class="ma-4" @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
      返回
    </v-btn>
    <v-container>
      <v-dialog :vlaue="!loaded" width="400" persistent>
        <v-card class="pa-5" :color="error?'error':'primary'" dark>
          <h5 v-if="!error">正在准备代码 (ID: {{ $route.params.id }})</h5>
          <v-progress-linear v-if="!error" indeterminate color="#fff"/>
          <div v-if="error">
            <h3>加载失败: {{ error }}</h3>
            <v-btn text color="primary" @click="$router.back()">返回</v-btn>
          </div>
        </v-card>
      </v-dialog>
      <v-form v-if="loaded" class="pa-8" v-model="valid">
        <h1>{{ templateData.label }}</h1>
        <h3>{{ templateData.desc }}</h3>
        <v-list>
          <v-list-item v-for="(item,index) of templateData.inputs" :key="index">
            {{ item.label }}
            <v-tooltip v-if="item.desc" bottom transition="scroll-y-transition">

              <template v-slot:activator="{on,attrs}">
                <v-icon style="cursor: help" color="primary" v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
              </template>

              <span>{{ item.desc }}</span>

            </v-tooltip>
            <div class="mr-3"/>
            <v-switch v-if="item.type==='boolean'" v-model="inputs[index]"></v-switch>
            <v-text-field v-if="item.type==='string'" v-model="inputs[index]" :suffix="item.suffix||''"></v-text-field>
            <v-text-field v-if="item.type==='number'" type="number" v-model="inputs[index]"
                          :rules="[v=>v?true:'请输入数字',v=>v<=(item.max||Infinity)&&v>=(item.min||-Infinity)?true:`超出数字限定范围${item.min|| -Infinity}~${item.max||Infinity}`]"
                          :suffix="item.suffix||''"></v-text-field>
          </v-list-item>
        </v-list>
        <v-btn rounded color="primary" :disabled="!valid" @click="makeCode" class="mb-5">生成代码</v-btn>
        <v-expand-transition>
          <v-alert v-show="successDialog" type="success" dark prominent @click="successDialog=false">
            <h3>代码已复制到剪贴板</h3>
          </v-alert>
        </v-expand-transition>
      </v-form>
    </v-container>
    <input type="text" id="dummyInput" style="position: absolute;left: -999px;top: -999px"/>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "CodeMaker",
  data: () => ({
    loaded: false,
    error: null,
    templateData: {},
    inputs: [],
    successDialog: false,
    valid: false
  }),
  mounted() {
    axios.get("/makerTemplates.json").then(d => {
      let templateData = d.data.filter(v => v.id === this.$route.params.id)[0];
      if (!templateData) {
        this.error = "无法找到指定的代码模板"
      } else {
        this.templateData = templateData;
        this.loaded = true;
        templateData.inputs.forEach(i => {
          this.inputs.push(i.default)
        })
      }
    }).catch(e => {
      this.error = e
    })
  },
  methods: {
    makeCode() {
      let code = this.templateData.template.replace("$ARGS", JSON.stringify(this.inputs))
      const dummyInput = document.querySelector("#dummyInput")
      dummyInput.value = code
      dummyInput.select();
      document.execCommand("copy")
      this.successDialog = true;
    }
  }
}
</script>

<style scoped>

</style>